import React, { Component } from 'react'

// import styles
import './leftmenucontent.scss'

class LeftMenuContent extends Component {

  render () {
    return (
      <div className='left__menu__content'>
        <div {...this.props}>
          {this.props.children}
        </div>
      </div>
    )
  }

}

export default LeftMenuContent



// WEBPACK FOOTER //
// ./src/app/shared/components/Menus/LeftMenu/Content/index.js